import { Component, OnInit } from '@angular/core';
import { RecordService } from '../../../services/record.service';
import { NotificationService } from '../../../services/notification.service';
import { Form, FormMode } from '../../../base/form';
import { FormGroup } from '@angular/forms';
import { FieldmagicDataGridApi, FieldmagicDataGridColumnDef, FieldmagicDataGridContextMenu, FieldmagicDataGridContextMenuParams, FieldmagicDataGridOnReadyEvent, FieldmagicDataGridOptions } from '../../../shared/components/data-grid/data-grid.component';
import { fallback, filled, generate_id } from '../../../shared/utils/common';
import { FieldmagicDataGridRelateDropdownInputConfig } from '../../../shared/components/data-grid/data-grid-inputs.component';
import { BehaviorSubject } from 'rxjs';
import { get } from 'lodash-es';
import { ViewService } from '../../../services/view.service';

@Component({
  selector: 'app-resource-line_items',
  template: `
        <div class="d-flex flex-column d-flex-gap">
          <div fieldmagicGridRow>
            <div fieldmagicGridColumn="12">
              <div class="w-100 d-flex d-flex-gap justify-content-end align-items-center">

                <fieldmagic-primary-button
                  variant="link"
                  [icon]="[
                    {
                      icon: 'plus-circle',
                      klass: 'text-success'
                    }
                  ]"
                  label="add_resources"
                  (click)="onClickAddResource()"
                  [disabled]="loading$ | async"
                >
                </fieldmagic-primary-button>

                <fieldmagic-primary-button
                  purpose="save"
                  (click)="onClickSave()"
                  [isInProgress]="loading$ | async"
                >
                </fieldmagic-primary-button>

              </div>
            </div>
          </div>

          <div fieldmagicGridRow>
            <div fieldmagicGridColumn="12">
              <fieldmagic-data-grid
                [columns]="columns"
                [options]="options"
                [menus]="menus"
                [fit]="true"
                (onReady)="onGridReady($event)"
              >
              </fieldmagic-data-grid>
            </div>
          </div>
        </div>
  `,
  styleUrls: ['./resource-line-items.component.scss'],
})
export class ResourceLineItemsComponent implements OnInit {

  readonly loading$ = new BehaviorSubject<boolean>(false);

  private fieldmagicDataGridApi?: FieldmagicDataGridApi<ResourceLineItem>;

  private arResourcesData: ResourceLineItem[] = [];

  readonly options: FieldmagicDataGridOptions = {
    enable_row_selection: 'multi',
  };

  readonly columns: FieldmagicDataGridColumnDef[] = [
    {
      label: 'resource_type',
      field_name: 'resource_type',
      field_type: 'relate',
      editable: true,
      input_config: <FieldmagicDataGridRelateDropdownInputConfig> {
        remote_config: {
          module_name: 'resource_types',
        },
        placeholder: 'select_resource_type',
      },
    },
    {
      label: 'quantity',
      field_name: 'quantity',
      field_type: 'numeric',
      editable: true,
    },
  ];

  readonly menus: FieldmagicDataGridContextMenu[] = [
    {
      label: 'remove_resource',
      is_row_action: true,
      action: (params) => this.onClickRemoveResource(params),
    },
  ];

  get currentRecordId(): string {
    return get(this.recordService.getParentData(), 'id', '');
  }

  constructor(
    private recordService: RecordService,
    private viewService: ViewService,
    private notificationService: NotificationService,
  ) {

  }

  ngOnInit() {
  }

  /**
   * @inheritdoc
   */
  setFormMode(mode: FormMode): void {
  }

  /**
   * @inheritdoc
   */
  setParentForm(parentForm: FormGroup): void {
  }

  /**
   * @inheritdoc
   */
  setField(field: Form<any>): void {
      fallback(get(field, 'default_value', []), {
        fallback: () => [],
      }).forEach( resource => {
      this.arResourcesData.push({
        id: get(resource, 'id'),
        resource_type: get(resource, 'resource_type'),
        quantity: get(resource, 'quantity'),
        record_order: get(resource, 'record_order'),
      });
    });
  }

  onGridReady(event: FieldmagicDataGridOnReadyEvent<ResourceLineItem>): void {
    this.fieldmagicDataGridApi = event.api
    this.fieldmagicDataGridApi.addItems(this.arResourcesData);
  }

  onClickAddResource(opts: {
    params?: FieldmagicDataGridContextMenuParams;
    above?: boolean;
    below?: boolean;
  } = {}): void {
    opts = Object.assign(
      {
        above: false,
        below: false
      },
      opts,
    );

    this.fieldmagicDataGridApi.addItems({
      id: generate_id(),
      resource_type: null,
      quantity: 0
    });
  }

  onClickRemoveResource(data: FieldmagicDataGridContextMenuParams): void {
    this.fieldmagicDataGridApi.removeItems(data.node.data);
  }

  onClickSave(): void {
    let arRecordToSave: ResourceLineItem[] = [];
    let bHasError: boolean = false;
    if (filled(this.currentRecordId)) {
      fallback(get(this.fieldmagicDataGridApi, 'data', []), {
        fallback: () => [],
      }).forEach( resourceData => {

        if (!filled(get(resourceData, 'resource_type.id'))) {
          bHasError = true;
          return;
        }

        arRecordToSave.push({
          id: get(resourceData, 'id'),
          resource_type: get(resourceData, 'resource_type'),
          quantity: get(resourceData, 'quantity'),
          record_order: get(resourceData, '__index'),
        });
      });

      if (!bHasError) {
        const objPayload = {
          resources: arRecordToSave
        };
        this.recordService.saveRecord('jobs', objPayload, this.currentRecordId).subscribe( () => {
          this.notificationService.notifySuccess('resources_succesfully_saved');
          this.viewService.reloadRecordView(objPayload);

        });
      } else {
        this.notificationService.notifyWarning('resource_type_required');
      }
    }

  }
}

type ResourceLineItem = {
  id: string;
  resource_type: string;
  quantity: number;
  record_order?: number;
}
